import React from 'react';
import CheckboxField from '../checkbox-field';
import DateTimeField from '../date-time-field';
import NumberField from '../number-field';
import RadioField from '../radio-field';
import SelectField from '../select-field';
import TextInputField from '../textfield';
import SecuredField from '../secured-field';
import RichTextField from '@nile/client_management/src/Components/fields/RichTextEditorField';

function ComponentResolver(props) {
  const { attribute, value } = props;

  const emitChange = (value) => {
    props.handleChange(value);
  };

  switch (attribute.fieldType) {
    case 'TEXT':
      return (
        <TextInputField
          value={value}
          attribute={attribute}
          handleChange={emitChange}
          multiline={false}
        />
      );
    case 'PASSWORD':
      return (
        <SecuredField
          value={value}
          label={attribute?.label}
          attribute={attribute}
          handleChange={emitChange}
        />
      );
    case 'PARAGRAPH':
      return (
        <TextInputField
          value={value}
          attribute={attribute}
          handleChange={emitChange}
          multiline={true}
        />
      );
    case 'NUMERIC':
      return (
        <NumberField
          value={value}
          attribute={attribute}
          handleChange={emitChange}
          mode="numeric"
        />
      );

    case 'DECIMAL':
      return (
        <NumberField
          value={value}
          attribute={attribute}
          handleChange={emitChange}
          mode="decimal"
        />
      );
    case 'DATE':
      return (
        <DateTimeField
          value={value}
          attribute={attribute}
          placeholderText="Choose Date"
          dateFormat="yyyy-MM-dd"
          handleChange={emitChange}
          showTimeInput={false}
        />
      );
    case 'DATETIME':
      return (
        <DateTimeField
          value={value}
          attribute={attribute}
          placeholderText="Choose Date and Time"
          dateFormat="yyyy-MM-dd h:mm aa"
          handleChange={emitChange}
          showTimeInput={true}
        />
      );
    case 'RADIO':
      return (
        <RadioField
          options={attribute.options}
          value={value}
          attribute={attribute}
          handleChange={emitChange}
        />
      );
    case 'CHECKBOX':
      return (
        <CheckboxField
          options={attribute.options}
          value={value}
          attribute={attribute}
          handleChange={emitChange}
        />
      );
    case 'SELECT':
      return (
        <SelectField
          attribute={attribute}
          value={value}
          handleChange={emitChange}
          isMulti={false}
        ></SelectField>
      );
    case 'MULTI_SELECT':
      return (
        <SelectField
          attribute={attribute}
          value={value}
          handleChange={emitChange}
          isMulti={true}
        ></SelectField>
      );
    case 'RICH_TEXT':
      return (
        <RichTextField
          label={attribute.label}
          value={value}
          handleChange={emitChange}
          isMulti={true}
          padded
        />
      );
    default:
      return <TextInputField attribute={attribute} handleChange={emitChange} />;
  }
}

export default ComponentResolver;
